import { useTranslation } from "react-i18next";
import Link from "@/components/feature/LocaleLink";
import imgServices from "@/assets/images/business-maintenance.jpg";
import imgSolutions from "@/assets/images/business-security.jpg";
import imgSatellite from "@/assets/images/site/satcom.jpg";

const CARDS = [
  { to: "/services", image: imgServices, tk: "cards.c1.title", dk: "cards.c1.desc", ak: "cards.c1.alt", tag: "SERVICES" },
  { to: "/solutions", image: imgSolutions, tk: "cards.c2.title", dk: "cards.c2.desc", ak: "cards.c2.alt", tag: "SOLUTIONS" },
  { to: "/satellite", image: imgSatellite, tk: "cards.c3.title", dk: "cards.c3.desc", ak: "cards.c3.alt", tag: "SATELLITE" },
];

// 사업 영역 카드 3개: 큰 이미지 + 짧은 설명 + VIEW MORE
export default function BusinessCards() {
  const { t } = useTranslation();

  return (
    <section id="business" className="bg-navy-gradient py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-4 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12" data-reveal>
          <div>
            <p className="text-xs tracking-[0.3em] font-semibold text-[var(--brand-orange)] uppercase mb-4 font-label">{t("cards.eyebrow")}</p>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
              {t("cards.title1")}
              <br />
              <span className="text-accent-300">{t("cards.title2")}</span>
            </h2>
          </div>
          <p className="text-foreground-300 max-w-md text-sm md:text-base leading-relaxed">{t("cards.desc")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-reveal data-reveal-stagger>
          {CARDS.map((c) => (
            <Link
              key={c.to}
              to={c.to}
              className="glow-card group relative block rounded-lg overflow-hidden bg-foreground-900 cursor-pointer"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={c.image}
                  alt={t(c.ak)}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/40 to-transparent"></div>
              </div>
              <div className="absolute inset-x-0 bottom-0 p-7">
                <div className="text-accent-300 text-xs tracking-[0.3em] font-semibold mb-2">{c.tag}</div>
                <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">{t(c.tk)}</h3>
                <p className="text-foreground-300 text-sm leading-relaxed mb-5">{t(c.dk)}</p>
                <span className="inline-flex items-center gap-2 text-background-50 text-sm font-semibold tracking-wider group-hover:gap-3 transition-all">
                  VIEW MORE
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
